import React, { useState } from 'react';

import { Button, Container, Grid, makeStyles, Typography, FormControl, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import moment from 'moment';

import { mapAvailableOptions, orderTrackingStatuses } from '../../models/Order';

const useStyles = makeStyles((theme) => {
  return {
    btn: {
      marginTop: '41px',
      width: '40%',
    },
    container: {
      maxWidth: '500px',
      padding: '26px',
    },
    formTitle: {
      color: '#172B4D',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    message: {
      color: '#999999',
      fontSize: '14px !important',
      lineHeight: '22px',
      marginBottom: '0px',
    },
    selectStatusTitle: {
      color: '#172B4D !important',
      fontSize: '14px !important',
      fontWeight: '600 !important',
      lineHeight: '22px',
      marginBottom: '8px',
      marginTop: '16px',
    },
    statusOption: {
      fontSize: '14px',
      lineHeight: '22px',
    },
  };
});
export default ({ onCancel, onConfirm, name, createdAt, status, hasPaymentDetail }) => {
  const classes = useStyles();
  const [selectedStatus, setSelectedStatus] = useState(status);

  const handleRadioChange = (event) => {
    setSelectedStatus(event?.target?.value);
  };

  const handleConfirm = () => {
    if (!onConfirm || typeof onConfirm !== 'function') return;
    onConfirm(selectedStatus);
  };

  const currentStatus = orderTrackingStatuses[status];
  const availableOptions = mapAvailableOptions(status, hasPaymentDetail);

  return (
    <Container disableGutters className={classes.container}>
      <Grid container className="text-left-">
        <Grid item xs={12} className="text-left">
          <Typography className={`${classes.formTitle}`}>
            Manage Order: {name} | {moment(createdAt).format('MM/DD/YYYY - hh:mm')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" className={`body-copy ${classes.message}`}>
            Select the new status of this order and click Save Order Status.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" className={`body-copy ${classes.selectStatusTitle}`}>
            Select Status:
          </Typography>
          <FormControl>
            <RadioGroup name="selectedOption" defaultValue={selectedStatus} onChange={handleRadioChange}>
              <FormControlLabel
                value={currentStatus.value}
                control={<Radio size="small" color="primary" />}
                label={`${currentStatus.label} (current status)`}
                labelPlacement="end"
              />
              {availableOptions.map((option) => (
                <FormControlLabel key={option.value} value={option.value} control={<Radio size="small" color="primary" />} label={option.label} labelPlacement="end" />
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={4} style={{ paddingRight: '6px' }}>
              <Button variant="link" style={{ width: '100%' }} fullWidth size="medium" color="primary" onClick={onCancel} className={classes.btn}>
                Cancel
              </Button>
            </Grid>
            <Grid item xs={8} style={{ paddingLeft: '6px' }}>
              <Button variant="contained" style={{ width: '100%' }} fullWidth size="medium" color="primary" onClick={handleConfirm} className={classes.btn}>
                Save Order Status
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};
